import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MultiDepositLimitResponse } from "@obg/ngx.core";
import { coerceBoolean } from "@obg/ngx.global.evo";

@Component({
	selector: "obg-m-multi-deposit-form",
	templateUrl: "multi-deposit-form.component.html",
	styleUrls: ["multi-deposit-form.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiDepositFormComponent {
	@Input() upcomingDepositLimits: MultiDepositLimitResponse | undefined;
	@Input() currentDepositLimits: MultiDepositLimitResponse | undefined;
	@Input() multiDepositLimitFormGroup: UntypedFormGroup | undefined;
	@Input() currencySymbol = "";
	@Input() @coerceBoolean() prefixCurrencySymbol = false;
	@Input() placeholder: string | undefined;
	@Input() weeklySuggestion: string | undefined;
	@Input() monthlySuggestion: string | undefined;
	@Input() validationKey: string | undefined;
	@Input() forceInvalidForm = false;
	@Input() hasCurrentLimits = false;
	@Input() showInputFields = false;
	@Input() @coerceBoolean() autoFocusFirstField = false;
	@Input() redirectToDeposit: boolean | undefined;
	@Input() sessionLimitUnset: boolean | undefined;
	@Input() setDepositLoading: boolean | undefined;
	@Input() hideDepositLimitCalculatorBanner: boolean | undefined;
	@Input() hideInputHint: boolean | undefined;
	@Output() formSubmitted = new EventEmitter<boolean>();
	@Output() toggleInputFields = new EventEmitter<boolean>();
}
